import { Component, OnInit } from '@angular/core';
import { UserService } from '../../ngx-admin-lte/services/user.service';
import { User } from "../../ngx-admin-lte/models/user";
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  styles: ['./login.css'],
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  public password: string;
  public email: string;
  public error: string = null;

  constructor(
    private userServ: UserService,
    private router: Router
  ) {
  }

  public ngOnInit() {
    console.log("loading de la page");
    window.dispatchEvent( new Event( 'resize' ) );
  }

  public login() {
    console.log("test du mot de passe");

    // si retour positif, log le user
    if ( environment.password.length > 0 && this.password === environment.password ) {

      const user1 = new User( {
          avatarUrl: 'assets/ciseaux.png',
          email: 'contact@salon-coiffure.com',
          firstname: environment.name,
          lastname: ''
      } );

      user1.connected = true;

      this.userServ.setCurrent( user1 );

      this.router.navigate( ['home'] );
    } else {
      this.error = "Mot de passe incorrect";
    }


  }

}
